<template>
  <div
    class="md:rounded-none border border-neutral-100 flex flex-col h-full w-full p-6 md:px-4 lg:px-6 xl:p-8 relative col-start-2"
    :class="{ 'bg-success bg-opacity-5': plan.name == 'Platinum' }"
  >
    <span
      class="hidden absolute -top-6 h-6 items-center justify-center left-0 text-center w-full rounded-t-2xl bg-success text-base text-white font-bold font-roboto"
      :class="{ '!flex': plan.name == 'Platinum' }"
    >
      {{ $t("popular") }}
    </span>
    <div class="flex-1 mt-4 mb-2">
      <h2 class="text-2xl font-bold font-roboto">{{ plan.name }}</h2>
    </div>
    <div class="flex flex-col">
      <template v-if="type == 'annually'">
        <div class="text-xl">
          <span class="font-bold text-danger"
            >-{{
              ((plan.monthly_price - plan.personal_yearly_price) * 100) /
              plan.monthly_price
            }}%</span
          >
          <span class="line-through text-base text-gray-400"
            >${{ plan.monthly_price }}</span
          >
        </div>
      </template>
      <div class="flex items-center text-bold font-b mb-2">
        <h4 class="text-2xl lg:text-3xl font-bold">$</h4>
        <h4 class="text-3xl lg:text-4xl font-bold">
          <template v-if="type == 'monthly'">{{ plan.monthly_price }}</template>
          <template v-if="type == 'annually'">{{
            plan.personal_yearly_price
          }}</template>
        </h4>
        <span class="ml-1.5 text-lg text-gray-400">/mo </span>
      </div>
      <div class="text-sm mb-4 text-gray-400">paid {{ type }}</div>

      <button
        class="flex justify-center items-center flex-grow font-semibold text-base rounded-lg px-4 h-10 pb-px border focus-visible:shadow-button-focus-gray box-border bg-white whitespace-nowrap transition"
        :class="{ 'text-white !bg-success': plan.name == 'Platinum' }"
        @click="startPlan()"
      >
        {{ $t("get_started") }}
      </button>

      <div class="mt-4 space-y-1 flex flex-col gap-2">
        <p class="font-bold text-base">{{ $t("features") }}</p>
        <div class="flex">
          <CircleCheckFilledIcon class="w-4 h-4 mt-1 mr-2 text-success" />
          <span class="w-full text-base"
            ><b>{{ plan.limit.qrcodes.toLocaleString() }}</b>
            {{ $t("dynamic_qr_codes") }}</span
          >
        </div>
        <div class="flex">
          <CircleCheckFilledIcon class="w-4 h-4 mt-1 mr-2 text-success" />
          <span class="w-full text-base"
            ><b>{{ plan.limit.scans.toLocaleString() }}</b>
            {{ $t("scans") }}</span
          >
        </div>
        <div class="flex">
          <CircleCheckFilledIcon class="w-4 h-4 mt-1 mr-2 text-success" />
          <span class="w-full text-base"
            ><b>{{ plan.limit.users.toLocaleString() }}</b>
            {{ $t("users") }}</span
          >
        </div>
        <div class="flex">
          <CircleCheckFilledIcon
            class="w-4 h-4 mt-1 mr-2 text-success"
            v-if="plan.limit.hide_logo"
          />
          <CircleXIcon class="w-4 h-4 mt-1 mr-2 text-gray-300" v-else />
          <span
            class="w-full text-base"
            :class="{ 'text-gray-300': !plan.limit.hide_logo }"
            >{{ $t("hide_qrdove_logo") }}</span
          >
        </div>
        <div class="flex">
          <CircleCheckFilledIcon
            class="w-4 h-4 mt-1 mr-2 text-success"
            v-if="plan.limit.vip_template"
          />
          <CircleXIcon class="w-4 h-4 mt-1 mr-2 text-gray-300" v-else />
          <span
            class="w-full text-base"
            :class="{ 'text-gray-300': !plan.limit.vip_template }"
            >{{ $t("vip_qr_code_frames") }}</span
          >
        </div>
        <div class="flex">
          <CircleCheckFilledIcon
            class="w-4 h-4 mt-1 mr-2 text-success"
            v-if="plan.limit.enable_api"
          />
          <CircleXIcon class="w-4 h-4 mt-1 mr-2 text-gray-300" v-else />
          <span
            class="w-full text-base"
            :class="{ 'text-gray-300': !plan.limit.enable_api }"
          >
            <template v-if="!plan.limit.enable_api">{{
              $t("disabled_api")
            }}</template>
            <template v-else
              ><b>{{ plan.limit.api.toLocaleString() }}</b>
              {{ $t("api_requests") }}</template
            >
          </span>
        </div>
        <div class="flex">
          <CircleCheckFilledIcon
            class="w-4 h-4 mt-1 mr-2 text-success"
            v-if="plan.limit.analytic.range"
          />
          <CircleXIcon class="w-4 h-4 mt-1 mr-2 text-gray-300" v-else />
          <span
            class="w-full text-base"
            :class="{ 'text-gray-300': !plan.limit.analytic.range }"
            >{{ $t("view_scan_date_ranges") }}</span
          >
        </div>
        <div class="flex">
          <CircleCheckFilledIcon
            class="w-4 h-4 mt-1 mr-2 text-success"
            v-if="plan.limit.analytic.range"
          />
          <CircleXIcon class="w-4 h-4 mt-1 mr-2 text-gray-300" v-else />
          <span
            class="w-full text-base"
            :class="{ 'text-gray-300': !plan.limit.analytic.range }"
            >{{ $t("location_device_analytics") }}</span
          >
        </div>
        <div class="flex">
          <CircleCheckFilledIcon
            class="w-4 h-4 mt-1 mr-2 text-success"
            v-if="plan.limit.analytic.widget"
          />
          <CircleXIcon class="w-4 h-4 mt-1 mr-2 text-gray-300" v-else />
          <span
            class="w-full text-base"
            :class="{ 'text-gray-300': !plan.limit.analytic.widget }"
            >{{ $t("widget_analytics") }}</span
          >
        </div>
        <div class="flex">
          <CircleCheckFilledIcon
            class="w-4 h-4 mt-1 mr-2 text-success"
            v-if="plan.limit.other_analytic"
          />
          <CircleXIcon class="w-4 h-4 mt-1 mr-2 text-gray-300" v-else />
          <span
            class="w-full text-base"
            :class="{ 'text-gray-300': !plan.limit.other_analytic }"
            >{{ $t("3party_conversion_analytics") }}</span
          >
        </div>
        <div class="flex">
          <CircleCheckFilledIcon
            class="w-4 h-4 mt-1 mr-2 text-success"
            v-if="plan.limit.support"
          />
          <CircleXIcon class="w-4 h-4 mt-1 mr-2 text-gray-300" v-else />
          <span
            class="w-full text-base"
            :class="{ 'text-gray-300': !plan.limit.support }"
            >{{ $t("support_via_discord_slack") }}</span
          >
        </div>
        <div class="flex">
          <CircleCheckFilledIcon
            class="w-4 h-4 mt-1 mr-2 text-success"
            v-if="plan.limit.analytic.export"
          />
          <CircleXIcon class="w-4 h-4 mt-1 mr-2 text-gray-300" v-else />
          <span
            class="w-full text-base"
            :class="{ 'text-gray-300': !plan.limit.analytic.export }"
            >{{ $t("export_data_analytics") }}</span
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { CircleXIcon, CircleCheckFilledIcon } from "vue-tabler-icons";
interface Plan {
  name: string;
  monthly_price: number;
  description: string;
  personal_yearly_price: number;
  limit: {
    scans: number;
    users: number;
    qrcodes: number;
    support: boolean;
    analytic: {
      range: boolean;
      device: boolean;
      export: boolean;
      social: boolean;
      widget: boolean;
      location: boolean;
    };
    hide_logo: boolean;
    enable_api: boolean;
    api?: any;
    integration: {
      ecommerce: number | string;
      google_sheet: number | string;
    };
    vip_template: boolean;
    other_analytic: boolean;
  };
}
const props = defineProps({
  plan: {
    type: Object as PropType<Plan>,
    required: true,
  },
  type: {
    type: String,
    required: true,
  },
});
const { locale } = useI18n();
const startPlan = () => {
  const url =
    "https://app.qrdove.com/plan?utm_medium=referral&utm_source=qrdove.com%2Fpricing&utm_campaign=home_navigator&locale=" +
    locale.value;
  var a = document.createElement("a");
  a.setAttribute("href", url);
  a.setAttribute("target", "_blank");
  a.click();
  a.remove();
};
</script>
